module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "message-data"
  }, [_c('span', {
    staticClass: "message-data-name"
  }, [_c('img', {
    attrs: {
      "src": _vm.message.user.avatar
    }
  }), _vm._v(" " + _vm._s(_vm.message.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "message-data-time"
  }, [_vm._v(_vm._s(_vm._f("fromNow")(_vm.message.timestamp)))])]), _vm._v(" "), _c('div', {
    staticClass: "message my-message"
  }, [(!_vm.isFile(_vm.message)) ? _c('div', [_vm._v(_vm._s(_vm.message.content))]) : _c('div', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dialog = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.message.image,
      "alt": "image"
    },
    on: {
      "click": _vm.copySrc
    }
  })]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Image View")])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('img', {
    staticClass: "full__sized",
    attrs: {
      "src": _vm.src,
      "alt": "image"
    }
  })])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f9eb6fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/SingleMessage.vue
// module id = 219
// module chunks = 1